import { createContext } from 'react';
import { useAlertHook } from '../hooks/useAlert';
import { useContext } from 'react';

const AlertContext = createContext({
  openAlert: false,
  title: '',
  closeAlert: () => {},
  showAlert: ({
    title = '',
    text = '',
    onSubmit = () => {},
    submitText = '',
  }) => {},
  onSubmit: () => {},
});

export const AlertProvider = ({ children }) => {
  const {
    openAlert,
    title,
    text,
    submitText,
    closeAlert,
    showAlert,
    onSubmit,
  } = useAlertHook();

  return (
    <AlertContext.Provider
      value={{
        openAlert,
        title,
        text,
        submitText,
        closeAlert,
        showAlert,
        onSubmit,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
